import React, { useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function OldPatientAppointment({ formData, setformData, error, setError }: any) {
  const [patient, setpatient] = useState([]);
  const [search, setsearch] = useState("");
  const [aciveId, setaciveId] = useState("");

  const handlePatientSearch = (e: any) => {
    setsearch(e.target.value);
  };

  const handlePatientSelect = (e: any) => {
    setaciveId(e._id);
    setformData((prevFormData: any) => ({
      ...prevFormData,
      patientId: e._id,
      fullName: e.fullName,
      gender: e.gender,
      mobileNo: e.mobileNo,
      address: e.address,
    }));
    // Clear error when patient is selected
    if (setError) {
      setError(false);
    }
  };

  useEffect(() => {
    baseUrl
      .get("appointment/findPatientsToAppointment", {
        headers: {
          status: true,
          keyword: search,
        },
      })
      .then((response) => {
        setpatient(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [search]);

  const formatAddress = (address: any) => {
    if (typeof address === "object" && address !== null) {
      return `${address.street || ""} ${address.no || ""}, ${address.city || ""}, ${address.district || ""}`.trim();
    }
    return address || "";
  };

  return (
    <div className="space-y-4">
      {/* Search Input */}
      <div className="relative">
        <SearchIcon
          className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500"
          sx={{ fontSize: 20 }}
        />
        <input
          type="search"
          onChange={handlePatientSearch}
          value={search}
          placeholder="Search patients by name or reg no..."
          className={`w-full pl-12 pr-4 py-3 bg-slate-50 dark:bg-slate-700 rounded-xl focus:border-transparent outline-none transition-all text-slate-700 dark:text-slate-200 placeholder:text-slate-400 dark:placeholder:text-slate-500 ${
            error && formData.patientId === ""
              ? "border-2 border-red-500 focus:ring-red-500 dark:border-red-400"
              : "border border-slate-200 dark:border-slate-600 focus:ring-2 focus:ring-indigo-500"
          }`}
        />
      </div>

      {/* Patient List */}
      <div className={`bg-slate-50 dark:bg-slate-700 rounded-xl max-h-[200px] overflow-y-auto ${
        error && formData.patientId === ""
          ? "border-2 border-red-500 dark:border-red-400"
          : "border border-slate-200 dark:border-slate-600"
      }`}>
        {patient.length === 0 ? (
          <div className="px-4 py-6 text-center text-slate-400 dark:text-slate-500">
            <PersonIcon sx={{ fontSize: 32 }} className="mb-2" />
            <p className="text-sm">No patients found</p>
          </div>
        ) : (
          <ul className="divide-y divide-slate-200 dark:divide-slate-600">
            {patient.map((p: any, i: number) => (
              <li
                key={i}
                onClick={() => handlePatientSelect(p)}
                className={`px-4 py-1 cursor-pointer transition-all flex items-center justify-between ${
                  aciveId === p._id
                    ? "bg-indigo-50 dark:bg-indigo-900/30 border-l-4 border-indigo-500"
                    : "hover:bg-slate-100 dark:hover:bg-slate-600"
                }`}
              >
                <div className="flex items-center gap-3">
                  <div
                    className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold text-sm ${
                      aciveId === p._id
                        ? "bg-gradient-to-br from-primary to-primaryLight"
                        : "bg-slate-300 dark:bg-slate-600"
                    }`}
                  >
                    {p?.fullName?.charAt(0)?.toUpperCase()}
                  </div>
                  <div>
                    <p className="font-medium text-slate-800 dark:text-slate-100">{p?.fullName}</p>
                    <p className="text-xs text-slate-500 dark:text-slate-400">{p?.regNo}</p>
                  </div>
                </div>
                {aciveId === p._id && (
                  <CheckCircleIcon className="text-indigo-500 dark:text-indigo-400" sx={{ fontSize: 20 }} />
                )}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Selected Patient Details */}
      {formData.fullName !== "" && (
        <div className="bg-indigo-50 dark:bg-indigo-900/20 rounded-xl p-4 border border-indigo-100 dark:border-indigo-800">
          <div className="flex items-center gap-2 mb-3">
            <CheckCircleIcon className="text-indigo-500 dark:text-indigo-400" sx={{ fontSize: 18 }} />
            <span className="text-sm font-semibold text-indigo-700 dark:text-indigo-300">Selected Patient</span>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="flex items-center gap-2">
              <PersonIcon className="text-indigo-400" sx={{ fontSize: 16 }} />
              <div>
                <p className="text-sm font-medium text-slate-800 dark:text-slate-100">{formData.fullName}</p>
                <p className="text-xs text-slate-500 dark:text-slate-400 capitalize">{formData.gender}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <PhoneIcon className="text-indigo-400" sx={{ fontSize: 16 }} />
              <p className="text-sm text-slate-700 dark:text-slate-300">{formData.mobileNo}</p>
            </div>
            <div className="col-span-2 flex items-start gap-2">
              <LocationOnIcon className="text-indigo-400 mt-0.5" sx={{ fontSize: 16 }} />
              <p className="text-sm text-slate-700 dark:text-slate-300 line-clamp-2">
                {formatAddress(formData.address)}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Error Message */}
      {error && formData.patientId === "" && (
        <p className="text-red-600 dark:text-red-400 text-xs font-medium mt-1">
          Please select a patient
        </p>
      )}
    </div>
  );
}

export default OldPatientAppointment;
